import config from '@/assets/config'
// import { getFrames, copyFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s6ScrollT = config.scenesScrollT[5]
const s7ScrollD = config.scenesScrollD[6]
const s7ScrollT = config.scenesScrollT[6]

// 淡入
const s7FadeD = s7ScrollD - s6ScrollT * 0.2
const s7FadeT = s6ScrollT * 0.2

// 各场景
const s7FingerFadeT = s7ScrollT * 0.025
const s7WechatFadeT = s7ScrollT * 0.025

const s7FingerD1 = s7ScrollD + s7FingerFadeT // 0.025T
const s7Wechat2FadeD = s7FingerD1 + s7FingerFadeT * 2 // 0.075T
const s7FingerD2 = s7Wechat2FadeD + s7WechatFadeT * 4 + s7FingerFadeT // 0.2T
const s7Wechat3FadeD = s7FingerD2 + s7FingerFadeT * 2 // 0.25T
const s7FingerD3 = s7Wechat3FadeD + s7WechatFadeT * 4 + s7FingerFadeT // 0.375T
const s7Wechat4FadeD = s7FingerD3 + s7FingerFadeT * 2 // 0.425T

// 点击妈妈头像
const s7HeadW1 = ww * 114 / 1125
const s7HeadH1 = s7HeadW1 / (114 / 117)
const s7HeadD = s7Wechat4FadeD + s7WechatFadeT * 4 // 0.525T
const s7HeadT = s7ScrollT * 0.025
const s7HeadScaleD = s7HeadD + s7HeadT // 0.55T
const s7HeadScaleT = s7ScrollT * 0.075
const s7HeadFadeD = s7HeadScaleD + s7HeadScaleT
const s7HeadFadeT = s7ScrollT * 0.025

// 缩放到静态
const s7StaticH = ww / (1125 / 2436)
const s7Static2H = wh
const s7Static2W = wh * 2715 / 2172
const s7HeadX1 = (1 - 620 / 1125) * ww
const s7HeadY1 = (1 - 548 / 2436 * s7StaticH / wh) * wh
const s7HeadX2 = 670 / 2715 * s7Static2W
const s7HeadY2 = (846 + 628) / 2172 * s7Static2H
const s7HeadH2 = 628 / 2172 * s7Static2H
const s7HeadW2 = s7HeadH2 * 114 / 117

// 滚动
const s7Static2MoveD = s7HeadFadeD + s7HeadFadeT // 0.65T
const s7Static2MoveT = s7ScrollT * 0.35
const s7Static2ScrollW = s7Static2W - ww

const s7TextT = s7ScrollT * 0.02
const s7Text1H = 317 / 2172 * wh
const s7Text1W = s7Text1H * 757 / 317
const s7Text1L = 600 / 2715 * s7Static2W
const s7Text1D = s7Static2MoveD + s7ScrollT * 0.03

const s7Text2H = 393 / 2172 * wh
const s7Text2W = s7Text2H * 936 / 393
const s7Text2L = 900 / 2715 * s7Static2W
const s7Text2D = s7Text1D + s7TextT * 4

const s7Text3H = 495 / 2172 * wh
const s7Text3W = s7Text3H * 1266 / 495
const s7Text3L = 1100 / 2715 * s7Static2W
const s7Text3D = s7Text2D + s7TextT * 4

const s7Text4H = 377 / 2172 * wh
const s7Text4W = s7Text4H * 936 / 377
const s7Text4L = 1500 / 2715 * s7Static2W
const s7Text4D = s7Text3D + s7TextT * 4

const s7EndFadeD = s7Text3D
const s7EndFadeT = s7TextT * 8

const animations = {
  s7_static: [
    {
      delay: s7HeadScaleD,
      duration: s7HeadScaleT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7FadeD,
      duration: s7FadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s7_wechat1new: [
    {
      delay: s7Wechat2FadeD,
      duration: s7WechatFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7Wechat2FadeD + s7WechatFadeT * 3,
      duration: s7WechatFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s7Wechat3FadeD,
      duration: s7WechatFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7Wechat3FadeD + s7WechatFadeT * 3,
      duration: s7WechatFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s7Wechat4FadeD,
      duration: s7WechatFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7FadeD,
      duration: s7FadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s7_wechat2: [
    {
      delay: s7Wechat2FadeD,
      duration: s7WechatFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7WechatFadeT * 2 }
    }
  ],
  s7_wechat3: [
    {
      delay: s7Wechat3FadeD,
      duration: s7WechatFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7WechatFadeT * 2 }
    }
  ],
  s7_wechat4: [
    {
      delay: s7HeadScaleD,
      duration: s7HeadScaleT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7Wechat4FadeD,
      duration: s7WechatFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s7_fingernormal: [
    {
      delay: s7HeadScaleD,
      duration: s7HeadScaleT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7FingerD2,
      duration: s7FingerFadeT,
      from: { alpha: 1 },
      to: { alpha: 0, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    },
    {
      delay: s7FingerD1,
      duration: s7FingerFadeT,
      from: { alpha: 1 },
      to: { alpha: 0, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    },
    {
      delay: s7FadeD,
      duration: s7FadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s7_fingerwork: [
    {
      delay: s7FingerD1,
      duration: s7FingerFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    }
  ],
  s7_fingergame: [
    {
      delay: s7FingerD2,
      duration: s7FingerFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    }
  ],
  s7_fingerexit: [
    {
      delay: s7Wechat2FadeD + s7WechatFadeT,
      duration: s7FingerFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    },
    {
      delay: s7Wechat3FadeD + s7WechatFadeT,
      duration: s7FingerFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    }
  ],
  s7_fingermother: [
    {
      delay: s7FingerD3,
      duration: s7FingerFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    }
  ],
  s7_fingermother2: [
    {
      delay: s7Wechat4FadeD + s7WechatFadeT,
      duration: s7FingerFadeT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7FingerFadeT }
    }
  ],
  s7_head: [
    {
      delay: s7HeadFadeD,
      duration: s7HeadFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7HeadD,
      duration: s7HeadT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s7HeadScaleD,
      duration: s7HeadScaleT,
      from: { width: s7HeadW1, height: s7HeadH1, x: s7HeadX1, y: s7HeadY1 },
      to: { width: s7HeadW2, height: s7HeadH2, x: s7HeadX2, y: s7HeadY2 }
    }
  ],
  s7_static2: [
    {
      delay: s7EndFadeD,
      duration: s7EndFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s7HeadFadeD,
      duration: s7HeadFadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s7Static2MoveD,
      duration: s7Static2MoveT,
      from: { x: 0 },
      to: { x: -s7Static2ScrollW }
    }
  ],
  s7_text1: [
    {
      delay: s7Static2MoveD,
      duration: s7Static2MoveT,
      from: { x: s7Text1L },
      to: { x: s7Text1L - s7Static2ScrollW }
    },
    {
      delay: s7Text1D,
      duration: s7TextT,
      from: { width: 0, height: 0, alpha: 0 },
      to: { width: s7Text1W, height: s7Text1H, alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7TextT * 2 }
    }
  ],
  s7_text4: [
    {
      delay: s7Static2MoveD,
      duration: s7Static2MoveT,
      from: { x: s7Text2L },
      to: { x: s7Text2L - s7Static2ScrollW }
    },
    {
      delay: s7Text2D,
      duration: s7TextT,
      from: { width: 0, height: 0, alpha: 0 },
      to: { width: s7Text2W, height: s7Text2H, alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7TextT * 2 }
    }
  ],
  s7_text3: [
    {
      delay: s7Static2MoveD,
      duration: s7Static2MoveT,
      from: { x: s7Text3L },
      to: { x: s7Text3L - s7Static2ScrollW }
    },
    {
      delay: s7Text3D,
      duration: s7TextT,
      from: { width: 0, height: 0, alpha: 0 },
      to: { width: s7Text3W, height: s7Text3H, alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7TextT * 2 }
    }
  ],
  s7_text2: [
    {
      delay: s7Static2MoveD,
      duration: s7Static2MoveT,
      from: { x: s7Text4L },
      to: { x: s7Text4L - s7Static2ScrollW }
    },
    {
      delay: s7Text4D,
      duration: s7TextT,
      from: { width: 0, height: 0, alpha: 0 },
      to: { width: s7Text4W, height: s7Text4H, alpha: 1, yoyo: true, repeat: 1, repeatDelay: s7TextT * 2 }
    }
  ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s7/spritesAnimations.js